import * as React from "react"
import Container from "@/components/container"
import DetailBackground from "@/components/background/detail-background"
import * as styles from "./index.module.scss"
import cls from "classnames"
import { RETURN_BUTTON_KEY } from "@/constants/common"
import ReturnButton from "@/components/return-button"

export const HeaderBar: React.FC<{ title: string }> = ({ title }) => {
  return (
    <DetailBackground>
      <Container className={styles.container}>
        <h1 className={cls(styles.h2)}>{title}</h1>
        <ReturnButton pageKey={RETURN_BUTTON_KEY.JOINT_SOLUTION} />
      </Container>
    </DetailBackground>
  )
}
